import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { useManageDetectionsLocation } from '../../hooks';

interface ManageDetectionsLinkProps {
    className?: string;
    /**
     * Content to display within the <button>
     */
    children: ReactNode;
    onClick?(): void;
}

/**
 * Renders a react-router-dom Link that navigates the user to the Uploads tab of the Manage
 * Detections modal if they do not have any audio files uploaded. Otherwise, sends them to the
 * Detection Settings tab of the Manage Detections modal.
 * @param props {@link ManageDetectionsLinkProps}
 * @returns <Link> that navigates user to the Manage Detections modal
 */
export const ManageDetectionsLink = ({
    className,
    children,
    onClick,
}: ManageDetectionsLinkProps): JSX.Element => {
    const location = useManageDetectionsLocation();

    return (
        <Link
            className={className}
            onClick={(): void => {
                if (onClick !== undefined) {
                    onClick();
                }
            }}
            to={location}
        >
            {children}
        </Link>
    );
};
